module.exports = __webpack_public_path__ + "static/media/jiaoyi1.b3edfa68.png";